import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CountryResponse } from '../models/holiday-manager.models';
import { GeographyCity, GeographyProvince, ProvinceCreate, ProvinceUpdate } from '../models/geography.models';
import { City } from '../models/address.models';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';

@Injectable({
  providedIn: 'root'
})
export class GeographyService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  #baseUrlV2 = this.#apiConfig.baseUrlV2;
  spinnerService: any;

  getCountries(): Observable<CountryResponse[]> {
    return this.#http.getData(`${this.#baseUrlV2}/country`, { showLoader: true, showMessage: false });
  }

  createCountry(country: CountryResponse): Observable<unknown> {
    return this.#http.postData(
      `${this.#baseUrlV2}/country`,
      { showLoader: true, showMessage: true, message: 'Country created successfully' },
      country
    );
  }

  updateCountry(country: CountryResponse): Observable<unknown> {
    return this.#http.putData(`${this.#baseUrlV2}/country/${country.id}`, country, {
      showLoader: true,
      showMessage: true,
      message: 'Country updated successfully'
    });
  }

  deleteCountry(countryId: string): Observable<unknown> {
    return this.#http.deleteData(`${this.#baseUrlV2}/country/${countryId}`, {
      showLoader: true,
      showMessage: true,
      message: 'Country deleted successfully'
    });
  }

  getAllProvinces(): Observable<GeographyProvince[]> {
    return this.#http.getData(`${this.#baseUrlV2}/province`, { showLoader: true, showMessage: false });
  }

  createProvince(province: ProvinceCreate): Observable<unknown> {
    return this.#http.postData(
      `${this.#baseUrlV2}/province`,
      { showLoader: true, showMessage: true, message: 'Province created successfully' },
      province
    );
  }

  updateProvince(province: ProvinceUpdate): Observable<unknown> {
    return this.#http.putData(`${this.#baseUrlV2}/province/${province.id}`, province, {
      showLoader: true,
      showMessage: true,
      message: 'Province updated successfully'
    });
  }

  deleteProvince(provinceId: string): Observable<unknown> {
    return this.#http.deleteData(`${this.#baseUrlV2}/province/${provinceId}`, {
      showLoader: true,
      showMessage: true,
      message: 'Province deleted successfully'
    });
  }

  getAllCities(): Observable<City[]> {
    return this.#http.getData(`${this.#baseUrlV2}/city`, { showLoader: true, showMessage: false });
  }

  getCities(provinceId: string): Observable<City[]> {
    return this.#http.getData(`${this.#baseUrlV2}/city?provinceId=${provinceId}`, {
      showLoader: true,
      showMessage: false
    });
  }

  createCity(city: GeographyCity): Observable<unknown> {
    return this.#http.postData(
      `${this.#baseUrlV2}/city`,
      { showLoader: true, showMessage: true, message: 'City created successfully' },
      city
    );
  }

  updateCity(city: GeographyCity): Observable<unknown> {
    return this.#http.putData(`${this.#baseUrlV2}/city/${city.id}`, city, {
      showLoader: true,
      showMessage: true,
      message: 'City updated successfully'
    });
  }

  deleteCity(cityId: string): Observable<unknown> {
    return this.#http.deleteData(`${this.#baseUrlV2}/city/${cityId}`, {
      showLoader: true,
      showMessage: true,
      message: 'City deleted successfully'
    });
  }
}
